import styled from 'styled-components';
import { IProduct } from '../../../interfaces/Product.interfaces';

export const PriceScreenSection = () => {
  return (
    <Container>
      <TitleSection>
        <RedTitle>{'로그인하고 매물 가격을 확인하세요'}</RedTitle>
      </TitleSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: calc(100% + 32px);
  height: calc(100% + 14px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-large, 16px);

  position: absolute;
  left: -16px;
  top: -8px;

  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(4px);
`;

const TitleSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 15.3px */
`;

const RedTitle = styled(Title)`
  color: var(--Light-Scheme-Color-primary-red, #ff3049);
`;
